



















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		street1: {
			type: String,
			required: false,
			default: '',
		},
		street2: {
			type: String,
			required: false,
			default: '',
		},
		city: {
			type: String,
			required: false,
			default: '',
		},
		provStateRegion: {
			type: String,
			required: false,
			default: '',
		},
		country: {
			type: String,
			required: false,
			default: '',
		},
		postalCode: {
			type: String,
			required: false,
			default: '',
		},
	},
});
